// extracted by mini-css-extract-plugin
module.exports = {"RegistrerTypeVirksomhet":"RegistrerTypeVirksomhet_RegistrerTypeVirksomhet__v8dlB","form":"RegistrerTypeVirksomhet_form__2A6Cd"};